export default __webpack_public_path__ + "static/media/384.69de10a2.png";